require("../bootstrap");

const url = process.env.MIX_MOWECO_API;

$("#updatePasswordForm").submit(function(e) {
  e.preventDefault();

  const email = $("#email").val();
  const password = $("#password").val();
  const confirmPassword = $("#password-confirm").val();
  const token = $('input[name="token"]').val();

  if (!password || !confirmPassword || !email) {
    toastr.error("Fields shouldn't be empty");
    return;
  }

  if (!emailIsValid(email)) {
    toastr.error("This email is not valid");
    return;
  }

  if (password !== confirmPassword) {
    toastr.error("Password doesnt match");
    return;
  }

  const params = {
    service: "MowecoUpdatePassword",
    params: {
      method: "POST",
      email: email,
      token: token,
      password: password,
      confirm_password: confirmPassword
    }
  };

  window.axios
    .post(url, params)
    .then(function(response) {
      if (response.data.status && response.data.status === 404) {
        resetFields(true);
        toastr.error(response.data.message);
        return;
      }

      if (
        response.data.result &&
        response.data.result.status &&
        response.data.result.status == 200
      ) {
        toastr.success(response.data.result.message);
        resetFields();
        return;
      }

      resetFields(true);
      toastr.error(
        "An error occurred while processing your request."
      );
    })
    .catch(function(error) {
      toastr.error(
        "An error occurred while processing your request."
      );      
      resetFields(true);

      // window.logger.error(window.loggerEvent, 'service-provider', error);
    });
});

$("#resetPasswordForm").submit(function(e) {
  e.preventDefault();

  const email = $("#email").val();

  if (!email && !emailIsValid) {
    toastr("This email is not valid");
    return;
  }

  const params = {
    service: "MowecoRecoveryPassword",
    params: { method: "POST", email }
  };

  window.axios
    .post(url, params)
    .then(function(response) {
      if (response.data.status && response.data.status === 404) {
        resetFields(true);
        toastr.error(response.data.message);
        return;
      }

      if (
        response.data &&
        response.data.status &&
        response.data.status == 200
      ) {
        toastr.success(response.data.message);
        resetFields();
        return;
      }

      resetFields(true);
      toastr.error(
        "An error occurred while processing your request. Please call the support."
      );
    })
    .catch(function(error) {
      toastr.error(
        "An error occurred while processing your request. Please call the support."
      );
      resetFields(true);
    });
});

const resetFields = (email = false) => {
  if (!email) {
    $("#email").val("");
  }

  $("#password").val("");
  $("#password-confirm").val("");  
};

const emailIsValid = email => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};
